import React from 'react';
import { Navigate , useSearchParams, useNavigate} from 'react-router-dom';


function ProtectedRoute({ element: Component }) {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    //console.log("ProtectedRoute");
    const userId = localStorage.getItem('user_id');
    if (!userId) {
        const userId = searchParams.get('user_id');
        const email = searchParams.get('email');
        if (userId) {
        localStorage.setItem("user_id", userId);
        localStorage.setItem("email", email);
        }
        else{
        return <Navigate to="/login" replace />;
        }

    }
    function getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for(let i = 0; i < ca.length; i++) {
          let c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "";
      }
      const user_type = getCookie("user_type");
      if (user_type != 'Admin')
      {
        navigate("/hr");
      }
      

    return Component;
}

export default ProtectedRoute;
